import { Group, SegmentedControl } from '@mantine/core';
import { VisibilityState } from '@tanstack/table-core';
import { MRT_RowData, MRT_TableInstance } from 'mantine-react-table';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dataColStates, resultsColStates } from '../../col-states';

interface ColumnSegmentedControlProps {
  table: MRT_TableInstance<MRT_RowData>;
}

enum ColumnType {
  Data = 'data',
  Result = 'result',
}

export const ColumnSegmentedControl = ({
  table,
}: ColumnSegmentedControlProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<ColumnType>(ColumnType.Data);

  const handleChange = useCallback(
    (v: string) => {
      setValue(v as ColumnType);
      switch (v) {
        case ColumnType.Data:
          table.setColumnVisibility(dataColStates as VisibilityState);
          break;
        case ColumnType.Result:
          table.setColumnVisibility(resultsColStates as VisibilityState);
          break;
        default:
          table.setColumnVisibility(resultsColStates as VisibilityState);
          break;
      }
    },
    [table],
  );

  return (
    <Group gap="md">
      <SegmentedControl
        color="pf-green"
        data={[
          {
            value: ColumnType.Data,
            label: 'Données saisies',
          },
          {
            value: ColumnType.Result,
            label: 'Résultats',
          },
        ]}
        onChange={handleChange}
        radius="xs"
        value={value}
      />
    </Group>
  );
};

export default ColumnSegmentedControl;
